import { useEffect } from "react";

import { useSelectedLocation } from "components";
import { useTypedQuery } from "hooks";
import { PendingChecklistsQueryKeys } from "modules/PendingChecklistsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { CheckInService } from "models";

const handleSelect = (checkInServices: CheckInService[]) => checkInServices.sort((a, b) => a.name.localeCompare(b.name));

export const useLocationServicesQuery = () => {
  const { selectedLocation } = useSelectedLocation();

  const query = useTypedQuery({
    queryKey: PendingChecklistsQueryKeys.locationServices,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { dealer_location_id: selectedLocation?.id }, baseUrl)).data.check_in_services,
    select: handleSelect,
    enabled: false
  });

  useEffect(() => {
    if (selectedLocation?.id) query.refetch();
  }, [selectedLocation?.id]);

  return query;
};
